export default {
  IN_PROGRESS: 'In progress',
  ERROR: 'Error',
  PAGE_NOT_FOUND: 'Page not found',
  SORRY_SOMETHING_WENT_WRONG: 'Sorry, something went wrong',
  SORRY_SERVICE_UNAVAILABLE: 'Sorry, the services are temporarily unavailable.',
  SORRY_THE_PAGE_YOU_ARE_LOOKING_FOR_WAS_NOT_FOUND:
    "The page you're looking for doesn't exist. We apologise for the inconvenience.",
  WE_ARE_WORKING_ON_IT:
    "We're working on a solution and we'll fix it as soon as possible. We apologise for the inconvenience.",
  GO_BACK: 'Go back',
  ENTITIES: 'Entities',
  INSTRUMENTS: 'Instruments',
  FUNDS: 'Funds',
  REQUESTS: 'Requests',
  RATING_NEWS: 'Rating news',
  RESEARCH: 'Research',
  EVENTS: 'Events',
  UPLOADS: 'Uploads',
  APPLY_FILTERS: 'Apply Filters',
  SELECT_ALL_ITEMS: 'Select all {0} items',
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less',
  RANGE: 'Range',
  NO_VALUE: 'No value',
  HOME: {
    COVERED_BONDS: 'Covered bonds',
  },
  ADMIN: {
    USERS: {
      TITLE: 'Users',
      ADD_USER: 'Invite user',
      PROVIDE_EMAIL: 'Provide email address to invite new user',
      EDIT_USER: 'Permissions',
      REVOKE: 'Revoke All Ratings',
      REVOKE_ALL_CONFIRMATION_TITLE: 'Revoke All Ratings',
      REVOKE_ALL_CONFIRMATION_MESSAGE: 'Do you really want to revoke access to all ratings?',
      RESEND_INVITATION: 'Re-send invitation',
    },
    RATINGS: {
      TITLE: 'Ratings',
      ADD_USER: 'Assign User',
      EDIT_USER: 'Edit user',
      REVOKE_ALL_CONFIRMATION_TITLE: 'Revoke All Users',
      REVOKE_ALL_CONFIRMATION_MESSAGE: 'Do you really want to revoke access for all users?',
    },
    RATING_USERS: {
      PROVIDE_EMAIL: 'Provide email address to add existing user',
      APPROVE_ALL_CONFIRMATION_TITLE: 'Approve Selected Users',
      APPROVE_ALL_CONFIRMATION_MESSAGE:
        'Do you really want to approve access for all selected users?',
      REVOKE_ALL_CONFIRMATION_TITLE: 'Revoke Selected Users',
      REVOKE_ALL_CONFIRMATION_MESSAGE:
        'Do you really want to revoke access for all selected users?',
    },
    SNACKS: {
      USER_ADDED: 'New user invited successfully',
      USER_ADD_FAILED: 'Failed to invite user',
      USER_UPDATED: 'User updated',
      USER_UPDATE_FAILED: 'Failed to update user',
      RATING_USER_ADDED: 'User added',
      RATING_USER_ADD_FAILED: 'Failed to add user',
      USERS_REVOKED: 'User(-s) revoked',
      USERS_REVOKE_FAILED: 'Failed to revoke user(-s)',
      RATING_USERS_REVOKED: 'User(-s) revoked',
      RATINS_USERS_REVOKE_FAILED: 'Failed to revoke user(-s)',
      RATING_USERS_APPROVED: 'User(-s) approved',
      RATING_USERS_APPROVE_FAILES: 'Failed to approve user(-s)',
      REVOKED_ALL_RATING_USERS: 'All rating users revoked',
      REVOKE_ALL_RATING_USERS_FAILED: 'Failed to revoke all rating users',
      COFIRMATION_SET: 'Updated Subscriber Confirmation',
      COFIRMATION_FAILED: 'Subscriber Confirmation update failed',
      RATING_CONTRACT_TYPE_SET: 'Contract Type has been updated',
      RATING_CONTRACT_TYPE_FAILED: 'Contract Type update failed',
    },
    LOG: {
      DATE: 'Date',
      STATUS: 'Status',
      MODIFIED_BY: 'Modified by',
    },
    USER_STATUS: {
      INVITED: 'Invited',
      CONFIRMED: 'Confirmed',
      ACTIVE: 'Active',
      INACTIVE: 'inactive',
      UNCONFIRMED: 'Unconfirmed',
      BLOCKED: 'Blocked',
      DISABLED: 'Disabled',
    },
    RATING_STATUS: {
      APPROVED: 'Approved',
      REVOKED: 'Revoked',
      INVITED: 'Invited',
    },
    RSR: {
      SUBSCRIBER_CONFIRMATION: 'Confirmation',
      SET_SUBSCRIBER_CONFIRMATION: 'Set Subscriber Confirmation',
      CONFIRMATION_BLANK: 'Not set',
      CONFIRMATION_SENT: 'Sent',
      CONFIRMATION_SIGNED: 'Signed',
      CONTRACT_TYPE: 'Contract Type',
      INVESTOR_REQUESTED: 'Investor Requested',
      ISSUER_SOLICITED: 'Issuer Solicited',
      VIEW_DETAILS: 'View Details',
      VIEW_LOG: 'View Log',
      USER_RATINGS_LOG_TITLE: 'Status History Log',
      REVOKE_ALL_USERS: 'Revoke All Users',
      RESTRICTED_SUBSCRIPTION_RATINGS: 'Restricted Subscription ratings',
      RSR_NAME: 'Name',
      TYPE: 'Type',
      RATING_TYPE: 'Rating type',
      REVOKE: 'Revoke',
      APPROVE: 'Approve',
      SET_CONTRACT_TYPE: 'Set Contract Type',
      NO_OF_REGISTERED_USERS: 'No. of registered users',
      NAME: 'Name',
      ORGANISATION: 'Organisation',
      EMAIL: 'E-mail',
      ACCESSIBLE_RATINGS: 'Accessible ratings',
      APPROVED_RATINGS: 'Approved ratings',
      USER_STATUS: 'User status',
      STATUS: 'Assignment',
      DATE: 'Date',
      AVAILABLE_RATINGS: 'Available ratings',
      ACCESS: 'Access',
      ENTITY_TYPE_ISSUE: 'Instrument',
      ENTITY_TYPE_ISSUER: 'Entity',
    },
  },
  PORTFOLIO: {
    UPLOADED_ITEMS: 'Uploaded items',
    VALIDATION_ERRORS: 'Validation errors',
    RENEWAL: 'Renewal',
    TYPE: 'Type',
    ISIN: 'ISIN',
    FUNDS: 'Funds',
    ITEMS: 'Items',
    LAST_ADDED: 'Last added',
    PORTFOLIO_NEWS: 'Portfolio news',
    NO_ITEMS: 'There are no items in this portfolio.',
    NO_ITEMS_DESC:
      'You can add entities, instruments, rating news and research to portfolios list.',
    PORTFOLIO_SUMMARY: 'Portfolio summary',
    PORTFOLIO_COVERAGE: 'Portfolio coverage',
    EMPTY_PORTFOLIO_COVERAGE: 'Upload portfolio to see coverage',
    ESG_COVERAGE: 'ESG coverage',
    CREDIT_RATING_COVERAGE: 'Credit rating coverage',
    COMPANIES_BY_REGION: 'Companies by region',
    COMPANIES_BY_INDUSTRY: 'Companies by industry',
    PORTFOLIO: 'Portfolio',
    UPLOAD_DATE: 'Upload date',
    ENTITIES: 'Entities',
    INSTRUMENTS: 'Instruments',
    CREDIT_RATING: 'Credit rating',
    CREDIT_REVIEW: 'Credit\n review',
    CREDIT_SCORE: 'Credit\n assessment',
    FUNDS_ANALYSIS: 'Funds',
    FUNDS_PEERGROUP: 'Peergroup',
    FUNDS_RANK: 'Rank',
    FUNDS_RATING: 'Rating',
    FUNDS_RATING_POINTS: 'Rating points',
    FUNDS_RETURN: 'Return (p.a.)',
    FUNDS_RISK: 'Risk',
    ESG_IMPACT_REVIEW: 'ESG impact review',
    OVERVIEW: 'Overview',
    COVERAGE: 'coverage',
    NOTIFICATIONS: 'Notifications',
    ACTIVITY: 'Activity',
    AVAILABLE_ENTITIES: 'Available entities',
    COUNTRY: 'Country',
    INDUSTRY: 'Industry',
    ENVIRONMENTAL: 'Environmental',
    SOCIAL: 'Social',
    GOVERNANCE: 'Governance',
    CLIMATE_LOSS: 'Climate\nLoss',
    PHYSICAL_RISK_LOSS: 'Physical\nRisk Loss',
    TRANSITION_RISK_LOSS: 'Transition\nRisk Loss',
    CREATE_PORTFOLIO: 'Create new portfolio',
    CREATE_PORTFOLIO_NAME: 'Portfolio name',
    CREATE_PORTFOLIO_DESCRIPTION: 'Add a description',
    UPLOAD_PORTFOLIO: 'Upload portfolio',
    UPDATE_PORTFOLIO: 'Update portfolio',
    DELETE_PORTFOLIO: 'Delete portfolio',
    RENAME_PORTFOLIO: 'Rename portfolio',
    DATE: 'Date',
    TITLE: 'Title',
    PORTFOLIO_DELETED: 'Portfolio(-s) deleted',
    NEW_PORTFOLIO_CREATED: 'New portfolio created',
    NOTIFICATIONS_ENABLED: 'Nofitications enabled',
    NOTIFICATIONS_DISABLED: 'Nofitications disabled',
    ITEMS_ADDED_TO_NEW_PORTFOLIO: 'Items added to new portfolio',
    UNABLE_TO_ADD_TO_NEW_PORTFOLIO: 'Unable to add entities to new portfolio',
    PORTFOLIO_NAME_WHITESPACE_WARNING: 'name cannot start or end with whitespace',
    UPLOADS_NAME: 'Name',
    UPLOADS_TYPE: 'Type',
    UPLOADS_CREATED: 'Created',
    UPLOADS_STATUS: 'Status',
    DATA_SOURCE: 'Data\n source',
    CITY: 'City',
    POSTCODE: 'Post\n code',
    RATING_TYPE: 'Rating\n type',
    ENTITY_RATING: 'Entity\n rating',
    OUTLOOK: 'Outlook',
    SORT_TERM_RATING: 'Short term\n rating',
    ASSESSMENT: 'Assessment',
    CREDIT_ASSESMENT: 'Credit assesment',
    COUNTRY_RISK: 'Country\n risk',
    UPDATE: 'Update',
    PROBABILITY_OF_DEFAULT: 'Probability\n of default',
    DEMAND_TYPE: 'Demand\n type',
    ALL_EVENTS: 'All Events',
    UNABLE_TO_REQUEST_SELECTED: 'Unable to request selected items.',
    YOU_CAN_NOT_REQUEST_MORE_THAN: 'You can not request more than',
    ITEMS_AT_ONCE: 'items at once.',
    ITEMS_COPIED_TO_NEW_PORTFOLIO: 'Items copied to new portfolio',
    ITEMS_MOVED_TO_NEW_PORTFOLIO: 'Items moved to new portfolio',
    RATING: 'Rating',
    RATING_TYPE_ONELINE: 'Rating type',
    ON_REQUEST: 'On Request',
    SUBSCRIPTION: 'Subscription',
    PUBLIC: 'Public',
    COUPON_RANGE: 'Coupon range',
    INVESTMENT_VOLUME: 'Investment volume',
    CURRENCY: 'Currency',
    POD: 'POD',
    TOTAL: 'Total',
    INDUSTRIES: 'Industries',
    SHORT_TERM_RATINGS: 'Short term ratings',
    COUNTRIES: 'Countries',
    MATURITY_DATE: 'Maturity date',
    ENTITY_RATING_SHOW_NO_VALUES: 'Show entities without ratings',
    INSTRUMENT_RATING_SHOW_NO_VALUES: 'Show instruments without ratings',
    PROBABILITY_OF_DEFAULT_ONELINE: 'Probability of default',
    FUND_PEERGROUP: 'Peergroup',
    FUND_RETURN_VALUE: 'Return value',
    FUND_RISK: 'Risk',
    FUND_RATING_POINTS: 'Rating points',
    FUND_RANK: 'Rank',
  },
  SEARCH: {
    SEARCH_FOR_ENTITIES_COUNTRIES_AND_INDUSTRIES:
      'Search for entities by name, LEI, ISIN, country and industry',
    HAVENT_FOUND_WHAT_YOU_ARE_LOOKING_FOR: "Haven't found what you're looking for?",
    REFINE_YOUR_SEARCH: 'Refine your search',
  },
  ENTITY: {
    NAME: 'Entity name',
    EXTENDED_DATA: 'Extended Data',
    CREDIT_SCORE: 'Credit Assessment',
    ENTITY_RATING: 'Entity rating',
    DEMAND_TYPE: 'Demand type',
    RATING_TYPE: 'Rating type',
    INDUSTRY: 'Industry',
    COUNTRY: 'Country',
    LEI: 'LEI',
    THIS_SCORE_IS_NOT_YET_AVAILABLE: `This assessment is not yet available. Assessments are typically available within three business days. 
    If the assessment does not appear in this period, please contact your personal advisor.`,
    ADDED: 'Added',
    LATEST_UPDATE: 'Latest update',
    PREVIOUS_RATING: 'Previous rating',
    PREVIOUS_OUTLOOK: 'Previous outlook',
    ULTIMATE_PARENT: 'Ultimate parent',
    SHORT_TERM_RATING: 'Short-term rating',
    PUBLIC_RATING: 'Public rating',
    SUBSCRIPTION_RATING: 'Subscription rating',
    RESTRICTED_SUBSCRIPTION_RATING: 'Restricted subscription rating',
    CHANGE_AS_OF_LATEST_RATING_ACTION: 'Change as of latest rating action',
    ACTIVITY: 'Activity',
    ACTIVITY_HINT: 'This column shows upgrades or downgrades during the last two weeks',
    FAILED_TO_EXPORT_ENTITIES: 'Failed to export entities',
    DOWNLOAD_TEMPLATE_FAIL: 'Failed to download sample portfolio template',
    UPLOAD_CUSTOM_DATA:
      'To request a assessment for this company, please upload the necessary financials',
    CUSTOM_DATA_UPLOADED: 'In progress',
    DATA_SOURCE_USER: 'User',
    DATA_SOURCE_SCOPE: 'Scope',
  },
  TOOLBAR: {
    ADD_TO_PORTFOLIO: 'Add to portfolio',
    COPY_TO_PORTFOLIO: 'Copy to portfolio',
    MOVE_TO_PORTFOLIO: 'Move to portfolio',
    REQUEST_SELECTED: 'Request selected',
    EXPORT_TO_EXCEL: 'Export to Excel',
    EXPORT_VIEW_TO_EXCEL: 'Export View',
    EXPORT_FULL_DATA_TO_EXCEL: 'Export Full Data',
    EXPORT_STARTED: 'Export requested. Open Notification Center to download the file.',
    TOGGLE_MONITORING: 'Toggle monitoring',
    DELETE: 'Delete',
    SHARE: 'Share',
    CREATE_NEW_PORTFOLIO: 'Create new portfolio',
    EXPORT_DISABLED_HINT:
      'Exporting is not available in free trial. Please contact your personal advisor or the Service Center to upgrade your account.',
  },
  COVERED_BONDS: {
    NAME: 'Instrument name',
    ISIN: 'ISIN',
    ENTITY_NAME: 'Entity',
    COUNTRY: 'Country',
    TYPE: 'Type',
    DEMAND_TYPE: 'Demand type',
    RATING: 'Rating',
    SENIORITY_TYPE: 'Seniority',
    OUTLOOK: 'Outlook',
    INSTRUMENT_VALUE: 'Volume',
    ALL: 'All',
    ALL_COUNTRIES: 'All countries',
    COVERED_BONDS: 'Covered bonds',
  },
  CREDIT_SPHERE: {
    INVITATION_CARD_TITLE: 'Credit Sphere is here',
    INVITATION_CARD_DESC:
      'Gain access to a growing number of 600+ rated entities in the sectors of Corporates, Banks and Sovereigns & Public Sector. Use our credit ratings for any purpose within your organisation.',
    INVITATION_CARD_YES: 'Go to shop',
    INVITATION_CARD_NO: 'Not now',
  },
  CREDIT_REVIEW: {
    CREDIT_REVIEW: 'Credit Review',
    CREDIT_REVIEW_REQUESTS: 'Credit Review requests',
    FREE_TRIAL_INVITATION_CARD_TITLE: 'Credit Review - Free Trial',
    FREE_TRIAL_INVITATION_CARD_DESC:
      'Reduce risk in your portfolio management strategy! Credit Review is your primary early warning system for corporate credit quality giving you total coverage through:\n\n- Risk knowledge\n- Monitoring & warning service\n- Dissemination & communication\n- Response capability',
    FREE_TRIAL_INVITATION_MODAL_NO: 'Not now',
    FREE_TRIAL_INVITATION_MODAL_YES: 'Go to subscriptions',
    ACTIVATE_YOUR_CREDIT_REVIEW_FREE_TRIAL_NOW: 'Activate your Credit Review Free Trial now!',
    MONITORING_CHANGE_SUCCESS:
      'Monitoring change requested successfully. It may take a while before the status is updated.',
    MONITORING_PENDING:
      'Requested monitoring change is pending. It may take a while before the status is updated.',
  },
  ESG: {
    NEXT_IMPACT_BY_REG_IND: 'Net externality impact by region and industry',
    FAILED_TO_DOWNLOAD_SAMPLE_TEMPLATE: 'Failed to download sample template',
    FAILED_TO_UPLOAD_COMPANIES: 'Failed to load companies',
    SCORING_TOOL: 'Create companies',
    SCORING_TOOL_DESC_1:
      'The upload of your companies will create the entries for the entities that have been identified from the upload file.',
    SCORING_TOOL_DESC_2:
      'To prepare the upload, please create a list of entities, using the template below. To finalise the companies upload, please click the "Next" button.',
    SCORING_TOOL_SUCCESS: 'Companies have been uploaded successfully.',
    SENTIMENT_REQUESTS: 'ESG Sentiment requests',
    IMPACT_REVIEW_SCORE: 'Impact review',
    CUSTOM_SCORE_TOOLTIP: 'Financial data provided by user',
    PORTFOLIO_UPLOAD: {
      INFO_1:
        'The upload of your portfolio will allow you to calculate the ESG impact score of this particular portfolio, based on the available scores.',
      INFO_2:
        'To prepare the upload, please create an upload file similar to the template provided below and upload it to ScopeOne following the portfolio wizard below.',
      INFO_3:
        'ESG Impact is only available for Corporates, any other entities will be added to your Portfolio but not available for requesting.',
      STEP_SCORES_AVAILABLE: 'Entities with ESG Score in our Systems.',
      STEP_SCORES_MISSING: 'Entities in our Systems without ESG Score.',
      STEP_COMPANIES_MISSING: `Entities that couldn't be identified. Please review and amend the file. 
        These items won't be included in the selected portfolio. 
        You can however use the following Template to include them in your ESG SCORING TOOL.`,
      STEP_NO_COMPANIES_MISSING: 'Unidentified entities.',
      DOWNLOAD_UNIDENTIFIED_ELEMENTS: 'Download a list of unidentifiable elements',
      FAILED_DOWNLOAD_PORTFOLIO_TEMPLATE: 'Failed to download sample portfolio template',
      FAILED_DOWNLOAD_MISSING_ELEMENTS_TEMPLATE: 'Failed to download list of missing elements',
      CREATE_PORTFOLIO: 'Create a portfolio to add the above file',
      SELECT_PORTFOLIO: 'Select portfolio',
      GOTO_PORTFOLIOS: 'Go to portfolio',
      STATUS_FAILED: 'FAILED',
    },
    ENTITY_REMOVAL_CONFIRMATION: 'Remove selected companies',
    ENTITY_REMOVAL_CONFIRMATION_DESC:
      "This change can't be undone. If you want to access this score after deleting this company, you will have to create it and upload the financial statements again. Are you sure you want to continue?",
    SCORE_REQUEST: {
      TITLE: 'Request ESG Score',
      REQUEST_FAILED: 'Request failed due to following reasons:',
    },
    SCORE_REQUESTING: {
      SUMMARY_TAB_REQUEST: `ESG Score is not available, yet. 
      Financial Statement has already been provided. 
      We are working on calculating ESG Score for you.`,
      SUMMARY_TAB_REQUESTED: `ESG Score is not available for this company. 
      You can provide Financial Statement, and we will calculate it for you.`,
      SUMMARY_TAB_UNLOCK_TOOLS: `ESG Score is not available for this company.`,
      SUMMARY_TAB_UNLOCK_RATINGS:
        'ESG data is available. Please subscribe to unlock access to our resources.',
      SCORING_TOOL_NO_PERMISSION: 'You have no permission to subscribe to ESG Scoring Tool.',
      SCORE_NOT_AVAILABLE: 'ESG Score is not available for this entity',
      SOMETHING_WENT_WRONG: 'Something went wrong. Please contact our support to get assistance.',
    },
    MISSING_FINANCIAL_STATEMENT: 'Missing financial statement',
    ONLY_AVAILABLE_FOR_CORPORATES: 'ESG Impact is only available for Corporates',
    LENDING_PORTFOLIO_DATA: 'Lending portfolio by region and industry',
    EXPOSURE_BY_REGION: 'Exposure by region',
    EXPOSURE_BY_INDUSTRY: 'Exposure by industry',
    LENDING_PORTFOLIO_IMPACT: 'Impact of the lending portfolio',
    IMPACT_BY_COUNTRY: 'Impact by country',
    IMPACT_BY_INDUSTRY: 'Impact by industry',
  },
  SENTIMENT: {
    SCORE_NOT_AVAILABLE: 'ESG Sentiment Score is not available for this entity.',
  },
  PORTFOLIO_UPLOAD: {
    STATUS_FAILED: 'FAILED',
    TITLE: `Portfolio Upload`,
    QUESTION_1: 'What do you want to upload?',
    INFO_1_1: 'The portfolio upload allows you to add',
    INFO_1_2: 'entities & instruments',
    OR: 'or',
    FUNDS: 'funds',
    INFO_1_3: 'to an existing or new portfolio. Please choose type of upload.',
    PREVIOUS: 'Previous',
    ENTITIES_PORTFOLIO_UPLOAD: 'Entities/Bonds portfolio upload',
    FUNDS_PORTFOLIO_UPLOAD: 'Funds portfolio upload',
    UPLOAD_PORTFOLIO: 'Upload Portfolio',
    INFO_ENTITIES_2_1:
      'The portfolio upload allows you to add entities and instruments to an existing or new portfolio',
    INFO_FUNDS_2_1: 'The portfolio upload allows you to add funds to an existing or new portfolio',
    CREATE_NEW_PORTFOLIO: 'Create new portfolio',
    TYPE_PORTFOLIO_NAME: 'Type portfolio name here',
    ADD_TO_EXISTING_PORTFOLIO: 'Add to existing portfolio',
    DOWNLOAD_INFO_1: 'Download provided template',
    DOWNLOAD_INFO_2: ' and select .csv, .xls, .xlsx\n file from your device',
    DOWNLOAD_TEMPLATE: 'Download template',
    ADD_TO_ISIN: 'Add entities related to ISIN identified instruments to the portfolio',
    SELECT_FILE: 'Select file',
    INFO_1: `The portfolio upload allows you to add entities to an existing or new portfolio.`,
    INFO_2: `Please use the template provided and select a file from your computer.`,
    INFO_3: ``,
    STEP_SCORES_AVAILABLE: `Success.\n Your file has been uploaded.\n Have ratings or scores that are immediately available for you.`,
    STEP_SCORES_MISSING: `The above number of entities could not be identified.`,
    STEP_COMPANIES_MISSING: `STEP_COMPANIES_MISSING`,
    STEP_NO_COMPANIES_MISSING: `STEP_NO_COMPANIES_MISSING`,
    SCORES_SIDE_NOTES: ``,
    UPLOADING_PORTFOLIO: 'Uploading portfolio...',
    YOU_WILL_BE_NOTIFIED: 'You will be notified when processing has finished.',
    SUMMARY_MAIN: `Your portfolio has been uploaded successfully.`,
    SUMMARY_SIDE_NOTES: `If you have questions concerning the upload, please contact the service center or your personal advisor via chat, email or telephone.`,

    ADD_INSTRUMENTS: `Add entities related to ISIN identified instruments to the portfolio`,
    DOWNLOAD_UNIDENTIFIED_ELEMENTS: `Click here to download the list of entities`,
    FAILED_DOWNLOAD_PORTFOLIO_TEMPLATE: `Failed to download sample portfolio template`,
    FAILED_DOWNLOAD_MISSING_ELEMENTS_TEMPLATE: `Failed to download list of missing elements`,
    CREATE_PORTFOLIO: `Create a portfolio or select an existing portfolio to upload your data.`,
    SELECT_PORTFOLIO: `Select portfolio`,
    GOTO_PORTFOLIOS: `Go to portfolio`,
    STATUS_ERROR: 'ERROR',
    STATUS_FINISHED: 'UPLOADED',
    STATUS_UPLOADING: 'Uploading...',
  },
  SHOP: {
    CHECKOUT: {
      TERMS_AND_CONDITIONS: 'Terms and Conditions',
      READ_AND_ACCEPT: 'I have read and accept ',
      OF_PRODUCT: ' of ',
      AND_CONFIRM: ' and confirm that I am authorised to execute this purchase.',
      TERMS_DOWNLOAD_FAILED: 'Failed to get T&C document. Please try again or contact support.',
    },
  },
  UPLOAD: {
    FILE_FORMAT: 'File format',
    MAX_SIZE: 'Max size',
    COLUMNS: 'Column heading',
    UPLOAD_SELECTED: 'The file selected below will be uploaded.',
    CHANGE_FILE: 'Change File',
    OUT_OF: 'out of',
    STEP_ONE: 'Coverage',
    STEP_TWO: 'Not Identified',
    STEP_THREE: 'Step three',
    BROWSE: 'Browse',
    NO_FILE_SELECTED: 'No file selected',
    FILE_TOO_LARGE: 'File is too large. Please upload a file below {0} MB.',
  },
  VIEW_DOCUMENTS: 'View documents',
  DOCUMENTS: 'Documents',
  CREATE_COMPANIES: 'Create Companies',
  UNLOCK: 'Unlock',
  NEXT: 'Next',
  PREVIOUS: 'Previous',
  CANCEL: 'Cancel',
  CONFIRM: 'Confirm',
  SAVE: 'Save',
  SUBMIT: 'Submit',
  DONE: 'Done',
  CONTINUE: 'Continue',
  DOWNLOAD_TEMPLATE: 'Download template',
  ERRORS: 'Errors',
  CREATE: 'Create',
  UPDATE: 'Update',
  ADD: 'Add',
  COPY: 'Copy',
  MOVE: 'Move',
  SUCCESS: 'Success',
  UNEXPECTED_ERROR: 'Unexpected error',
  OTHER: 'other',
  UNKNOWN: 'Unknown',
  NO_ITEMS_FOUND: 'Sorry, no matching records found.',
  PORTFOLIO_EVENTS: {
    NAME: 'Name',
    DATE: 'Date',
    CATEGORY: 'Category',
    REGION: 'Region',
    INDUSTRY: 'Industry',
  },
};
